<form-layout
    [showSave]="canSave"
    (onSave)="onSaveClick()"
    (onBack)="onBackClick()"
    (onNext)="onSaveAndNextClick()">

    <organisation-eligible-form [form]="contactDataProcessStepForm" [ausschreibungId]="this.anfrage.ausschreibungId"></organisation-eligible-form>
</form-layout>
